import React from 'react';
import ResellerClaimRegexBody from '../components/constructed/reseller-claim-regex/ResellerClaimRegexBody';

export const ResellerClaimRegexPage: React.FC = () => (
    <>
        <br />
        <ResellerClaimRegexBody />
    </>
);
